import styled, {css} from 'styled-components';
import {dFlexColumnCenter, dFlexCenter, dFlex, alignCenter} from '../../../../globalVariables/GlobalFlex';
import {ellipsisLines} from '../../../../globalVariables/GlobalVariables';

export const body = styled.div`
    flex: 1;
    width: 100%;
    ${dFlexColumnCenter};
    gap: var(--space-md);
    padding: var(--space-md) 0;
`;

export const title = styled.h3`
    font-size: var(--font-size-heading-card);
    font-weight: var(--font-weight-bold);
    line-height: 1.2;
    text-align: center;
    word-break: break-word;
    margin-inline: var(--space-lg);
`;

export const ticketName = styled.div<{$accessible?: boolean}>`
    align-self: stretch;
    margin-inline: var(--space-lg);
    background: var(--color-bg-surface-default);
    padding: var(--space-sm) var(--space-md);
    border-radius: var(--border-radius-border-radius-md);
    font-size: var(--font-size-body-small);
    line-height: 1.3;
    text-align: center;
    ${p => p.$accessible && css`
        ${dFlex}
        ${alignCenter}
        gap: var(--space-sm);
    `}
`;

export const a11yIcon = styled.span`
    flex: none;
    width: 24px;
    height: 24px;
    border-radius: var(--border-radius-border-radius-full);
    background: var(--primitive-blue-600);
    ${dFlexCenter}

    svg {
        width: 14px;
        height: 14px;
    }
`;

export const ticketNameText = styled.span`
    flex: 1;
    min-width: 0;
    ${ellipsisLines(2)}
`;

export const ticketNo = styled.div`
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-regular);
    color: var(--color-text-subtle);
    text-align: center;
`;

export const seatInfo = styled.div`
    align-self: stretch;
    margin-inline: var(--space-lg);
    ${dFlex}
    justify-content: center;
    gap: var(--space-xl);
`;

export const seatPart = styled.div`
    ${dFlexColumnCenter}
    gap: 2px;
    min-width: 0;
`;

export const seatPartLabel = styled.span`
    font-size: var(--font-size-caption);
    color: var(--color-text-subtle);
`;

export const seatPartValue = styled.span`
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-bold);
    max-width: 120px;
    ${ellipsisLines(1)}
`;
